var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkGoerliLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 60c16.569 0 30-13.431 30-30s-13.431-30-30-30-30 13.431-30 30 13.431 30 30 30z",
    fill: "#2f99f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.12 9-.287.957v27.774l.287.281 13.122-7.62z",
    fill: "#d5e5ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.122 9-13.122 21.392 13.122 7.62z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.12 40.45-.162.193v9.893l.162.464 13.13-18.167-13.13 7.616z",
    fill: "#d5e5ee"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m30.122 51v-10.55l-13.122-7.619z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m30.12 38.027 13.122-7.62-13.122-5.86z",
    fill: "#58a9ec"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m17 30.406 13.122 7.621v-13.48z",
    fill: "#d5e5ee"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkGoerliLogo);
export default __webpack_public_path__ + "static/media/network-goerli-logo.40d89892925720c9671ed55e8cd12633.svg";
export { ForwardRef as ReactComponent };